import { Injectable } from '@angular/core';
import { distinctUntilPropertiesChanged } from '@lib/rxjs/distinct-until-properties-changed';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { UserDto } from './user.dto';

@Injectable()
export class UserService {
  public user$: Observable<UserDto> = this.authService.identity$.pipe(
    map((decodedIdToken) => UserDto.fromDecodedToken(decodedIdToken)),
    distinctUntilPropertiesChanged(),
    shareReplay(1),
  );

  constructor(private authService: AuthService) {}
}
